import { PathWithId } from "@constellation-academy/epic-ui";
import { ReportDetailsPath } from "../report-details/report-details.paths";

export class ReportsPath extends PathWithId<typeof ReportsPath> {
	static readonly pathKey = "reports";
	static readonly idKey = "reportId";
	static readonly childPaths = [ReportDetailsPath];
}
